<y42-context-menu-color-button
  [color]="color || defaultColor"
  [faIcon]="['fas', 'circle']"
  tooltip="Color"
  (colorChanged)="colorChanged.emit($event)"
></y42-context-menu-color-button>
